
import { CNavItem } from '@coreui/react'

const _nav = [
  // {
  //   component: CNavItem,
  //   name: 'Dashboard',
  //   to: '/dashboard',
  //   icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  //   badge: {
  //     color: 'info',
  //     text: 'NEW',
  //   },
  // },
  // {
  //   component: CNavTitle,
  //   name: 'Axle',
  // },
  // {
  //   component: CNavItem,
  //   name: 'Division',
  //   to: '/division',
  // },
  // {
  //   component: CNavItem,
  //   name: 'Station',
  //   to: '/station',
  // },
  // {
  //   component: CNavItem,
  //   name: 'Zone',
  //   to: '/zone',
  // },
  // {
  //   component: CNavItem,
  //   name: 'Device',
  //   to: '/device',
  // },
  // {
  //   component: CNavItem,
  //   name: 'Device Status',
  //   to: '/device_status',
  // },
  // {
  //   component: CNavItem,
  //   name: 'Alert History',
  //   to: '/alert-history',
  // },
  //
  // {
  //   component: CNavItem,
  //   name: 'Alert Config',
  //   to: '/alert-conf',
  // },
  // {
  //   component: CNavItem,
  //   name: 'HABD History',
  //   to: '/habd-history',
  // },
  {
    component: CNavItem,
    name: 'Device Reading',
    to: '/device-reading',
    id:"devicereading"
  },
  {
    component: CNavItem,
    name: 'SMS Alert',
    to: '/sms-alert',
    id:'smsalert'
  },
  {
    component: CNavItem,
    name: 'Reading Overview',
    to: '/reading-overview',
    id:"readingoverview"
  },
  {
    component: CNavItem,
    name: 'Status History',
    to: '/status-history',
    id:"statushistory"
  },
  {
    component: CNavItem,
    name: 'Statistics report',
    to: '/statistics-report',
    id:"statisticsreport"
  },
  {
    component: CNavItem,
    name: 'Map view',
    to: '/map-view',
    id:"mapview"
  },
  {
    component: CNavItem,
    name: 'User Setting',
    to: '/user-setting',
    id :"usersetting"
  },
  {
    component: CNavItem,
    name: 'Report Device Fault',
    to: '/device-fault',
    id :"fault"
   },
  {
    component: CNavItem,
    name: 'HABD Machine Details',
    to: '/habd-details',
    id:'habddetails'
   },
  {
    component: CNavItem,
    name: 'Compatibility Support',
    to: '/compatibility',
    id:"compatibility"
  },
  {
    component: CNavItem,
    name: 'Rule Engine',
    to: '/rule-engine',
    id:"ruleengine"
  },
  {
    component: CNavItem,
    name: 'Tickets',
    to: '/tickets',
    id: 'tickets',
  },
  // {
  //   component: CNavItem,
  //   name: 'Search Table2',
  //   to: '/table2',
  // },
  // {
  //   component: CNavGroup,
  //   name: 'Pages',
  //   icon: <CIcon icon={cilStar} customClassName="nav-icon" />,
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: 'Users',
  //       to: '/users',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Login',
  //       to: '/login',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Register',
  //       to: '/register',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Error 404',
  //       to: '/404',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Error 500',
  //       to: '/500',
  //     },
  //   ],
  // },
]

// Routes that non-super-admin users may visit even though they are not (or
// cannot be) listed as static sidebar entries. ZoneGuard consults this list
// before falling back to the super-admin-only check.
export const clientRoutes = [
  '/tickets',
  '/tickets/new',
  /^\/tickets\/\d+$/, // /tickets/:id (numeric). Reserved words like /tickets/analytics
                      // and admin-only sub-paths like /tickets/:id/edit are intentionally
                      // not matched and fall through to the super-admin check.
]

export default _nav
